module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/189UiIN/tc-custom/9781504075817.jpg?1705025993527",
      "alt": "This image is the cover for the book Martyr of Auschwitz"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Martyr of Auschwitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A researcher seizes an opportunity to find out what happened to her grandfather during WWII—and discovers a present-day threat as she retraces his steps . . .")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Munich, 1938")]), _vm._v(": Two men successfully infiltrate the notorious conference at which Prime Minister Chamberlain will hand Czechoslovakia over to Hitler. One is an American radio correspondent determined to stop the gullible and dangerous act with a dramatic protest. But the other pulls a gun, and pandemonium ensues."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Britain, 2013")]), _vm._v(": History researcher Emma Drake has always wondered what really happened to her grandfather. The infamous Munich agreement was signed and Bradley Wilkes disappeared from the pages of history. Ever since, the family has avoided the topic and let the mystery linger. Now, through her academic work, Emma has stumbled onto an opportunity to investigate. Her quest will take her to America, Germany, and beyond—and into a present-day plot that could have explosive international consequences—in this novel of suspense and adventure from the author of "), _c('i', [_vm._v("The Fuhrer’s Orphans")]), _vm._v(".\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Laws\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0